import { render, staticRenderFns } from "./CapturaSubTab.vue?vue&type=template&id=44b06396&"
import script from "./CapturaSubTab.vue?vue&type=script&lang=js&"
export * from "./CapturaSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports